import styled from 'styled-components';

export const SliderContainer = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;

  .slick-slide > div {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .slick-dots {
    bottom: 20px;
  }

  .slick-dots li button:before {
    font-size: 14px;
    color: white !important;
    opacity: 1;
  }

  .slick-prev
  {
    z-index: 10;
    margin-left:30px
    
  }
  .slick-next {
    z-index: 10;
    margin-right:40px
    
  }


  .slick-prev:before,
  .slick-next:before {
    color: white;
    font-size: 42px;
    opacity: 1;
  }

  @media screen and (max-width: 768px) {
    height: 60vh;

    .slick-prev:before,
    .slick-next:before {
      font-size: 26px;
    }

    .slick-dots li button:before {
      font-size: 10px;
    }
  }
`;

//  background-color: black;  default background color
export const SlideImage = styled.img`
  width: 100vw;
  height: 100vh;
  object-fit: contain; /* ✅ Show full image without cutting */
  background-color: #fff; /* ✅ Fill empty space with black background */
  

  @media screen and (max-width: 768px) {
    height: 60vh;
  }
`;
